import { useEvents } from "api/events";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { CustomEventSchema } from "components/Layout/CustomEvent/SchemaForm/CustomEventSchema";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { useStyles } from "./CustomEventSchema";

export function EditCustomEventSchema() {
  const { useCustomEventSchemaDetails } = useEvents();
  const { id: customEventSchemaID } = useParams<{ id: string }>();
  const { data: customEventSchemaDetails } =
    useCustomEventSchemaDetails(customEventSchemaID);
  const { message } = useMessage();
  const classes = useStyles();

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "customEventSchemas" }),
      path: links.customEventsSchemaList,
    },
  };

  return (
    <>
      <TopHeader
        title={
          customEventSchemaDetails
            ? `${message({ id: "editEventSchema" })} "${
                customEventSchemaDetails.name
              }"`
            : ""
        }
        clearLink={links.customEventsSchemaList}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.form}>
        {customEventSchemaDetails ? (
          <CustomEventSchema
            editMode
            initialValues={{
              eventType: customEventSchemaDetails.eventType,
              name: customEventSchemaDetails.name,
              schema: customEventSchemaDetails.schema,
              active: customEventSchemaDetails.active,
            }}
          />
        ) : null}
      </div>
    </>
  );
}
